<form
  id="service-request-services-form"
  #servicesForm="ngForm">
  <div
    class="row u-p-x-only u-mt--large u-mb--large flex between"
    *ngIf="!isRaResultReceived && equipmentList?.length">
    <div class="c-section-title col-6 col-lg-3">
      {{ equipmentList?.length }}
      {{ localizationConstants.SERVICE_REQUEST_TOOLS | translate }}
    </div>
    <div class="col-6 col-lg-3">
      <button
        type="button"
        class="button button--lg button-primary button-block flex middle center button__stepper-start"
        (click)="startRequestClick.emit()"
        [class.form-invalid]="isServiceFormInvalid">
        <span class="button__label button__mobile-label">{{
          localizationConstants.BUTTON_START_REQUEST | translate
        }}</span>
        <mat-icon
          svgIcon="chevronRight"
          color="white"></mat-icon>
      </button>
      <div>
        <span
          class="c-form-alert"
          *ngIf="isServiceFormInvalid">
          {{ localizationConstants.SERVICE_REQUEST_FORM_ERRORS | translate }}
        </span>
      </div>
    </div>
  </div>

  <div [hidden]="!equipmentList?.length">
    <div class="row u-p-x-only">
      <div class="col">
        <div class="u-scroll--horizontal">
          <div
            id="service-request-table"
            class="col u-table-fix-head">
            <table
              *ngIf="!isRaResultReceived"
              mat-table
              matSort
              [dataSource]="dataSource"
              class="c-table">
              <ng-container
                *ngFor="let col of columns"
                [matColumnDef]="col.key">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header>
                  {{ col.title | translate }}
                </th>

                <td
                  mat-cell
                  *matCellDef="let element">
                  <ng-container [ngSwitch]="col.key">
                    <div *ngSwitchCase="'serialNumber'">
                      <div
                        class="c-clickable"
                        [routerLink]="[
                          routeNameConstants.TOOLS_DETAILS_BASE,
                          element.companyId,
                          element.serialNumber,
                        ]">
                        {{ element[col.key] }}
                      </div>
                    </div>
                    <div *ngSwitchCase="'toolId'">
                      <div
                        class="c-clickable"
                        [routerLink]="[
                          routeNameConstants.TOOLS_DETAILS_BASE,
                          element.companyId,
                          element.serialNumber,
                        ]">
                        {{ element[col.key] }}
                      </div>
                    </div>
                    <div *ngSwitchCase="'modelNumber'">
                      <div>{{ element[col.key] }}</div>
                    </div>
                    <div *ngSwitchCase="'requestedService'">
                      <mat-select
                        [placeholder]="
                          localizationConstants.SERVICE_REQUEST_REQUESTED_SERVICE_PLACEHOLDER
                            | translate
                        "
                        [id]="'requestedService' + element.serialNumber"
                        [name]="'requestedService' + element.serialNumber"
                        (selectionChange)="onServiceChange()"
                        [(ngModel)]="element.requestedService"
                        [class.is-invalid]="isServiceFormInvalid && !element.requestedService"
                        type="text"
                        class="c-select c-select--md cell-mw-150"
                        [compareWith]="compareWithFnServiceRequested"
                        required>
                        <mat-option
                          *ngFor="let service of options?.requestedServicesOptions"
                          [value]="service.value">
                          {{ service.displayValue ? service.displayValue : service.value }}
                        </mat-option>
                        <mat-option [value]="'other'">
                          {{ localizationConstants.SERVICE_REQUEST_OTHER_SERVICE | translate }}
                        </mat-option>
                      </mat-select>
                    </div>
                    <div *ngSwitchCase="'maxPrice'">
                      <mat-select
                        [placeholder]="
                          localizationConstants.SERVICE_REQUEST_MAX_PRICE_PLACEHOLDER | translate
                        "
                        [id]="'maxPrice' + element.serialNumber"
                        [name]="'maxPrice' + element.serialNumber"
                        [(ngModel)]="element.maxPrice"
                        (selectionChange)="onMaxPriceChange()"
                        [class.is-invalid]="isServiceFormInvalid && !element.maxPrice"
                        type="text"
                        class="c-select c-select--md cell-mw-150"
                        required>
                        <mat-option
                          *ngFor="let p of options?.approvedMaxPriceOptions"
                          [value]="p.value">
                          {{ p.displayValue ? p.displayValue : p.value }}
                        </mat-option>
                      </mat-select>
                    </div>
                    <div *ngSwitchCase="'customerComments'">
                      <input
                        [id]="'toolComments' + element.serialNumber"
                        [name]="'toolComments' + element.serialNumber"
                        [(ngModel)]="element.customerComments"
                        type="text"
                        class="c-input c-input--gamma cell-mw-150"
                        [class.is-invalid]="
                          isServiceFormInvalid &&
                          element.requestedService === 'other' &&
                          !element.customerComments
                        "
                        [required]="element.requestedService === 'other'" />
                    </div>
                  </ng-container>
                </td>
              </ng-container>

              <ng-container matColumnDef="action1">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="action">
                  <button
                    (click)="removeAll.emit()"
                    type="button"
                    class="button--sm button-secondary button-block">
                    {{ localizationConstants.SERVICE_REQUEST_REMOVE_ALL | translate }}
                  </button>
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  class="action">
                  <service-request-button [tool]="element"></service-request-button>
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="columnKeysAll"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: columnKeysAll"
                class="c-table__row"></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
